"use client"

import { ThemeType } from "@/context/ThemeContext"
import {
  ComputerDesktopIcon,
  MoonIcon,
  SunIcon,
} from "@heroicons/react/24/outline"
import { AnimatePresence, motion } from "framer-motion"

// Create motion components
const MotionDiv = motion.create("div")
const MotionButton = motion.create("button")

// Extract theme toggle button to a separate component
export const ThemeToggleButton = ({
  theme,
  toggleTheme,
}: {
  theme: ThemeType
  toggleTheme: () => void
}) => {
  return (
    <MotionButton
      onClick={toggleTheme}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="flex h-10 w-10 items-center justify-center text-tertiary transition-colors hover:text-default"
      aria-label="Toggle theme"
    >
      <AnimatePresence mode="wait">
        {theme === "dark" && (
          <MotionDiv
            key="dark-icon"
            initial={{ opacity: 0, rotate: -90 }}
            animate={{ opacity: 1, rotate: 0 }}
            exit={{ opacity: 0, rotate: 90 }}
            transition={{ duration: 0.3 }}
          >
            <SunIcon className="h-5 w-5 text-default" />
          </MotionDiv>
        )}
        {theme === "light" && (
          <MotionDiv
            key="light-icon"
            initial={{ opacity: 0, rotate: 90 }}
            animate={{ opacity: 1, rotate: 0 }}
            exit={{ opacity: 0, rotate: -90 }}
            transition={{ duration: 0.3 }}
          >
            <MoonIcon className="h-5 w-5 text-default" />
          </MotionDiv>
        )}
        {theme === "system" && (
          <MotionDiv
            key="system-icon"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.3 }}
          >
            <ComputerDesktopIcon className="h-5 w-5 text-default" />
          </MotionDiv>
        )}
      </AnimatePresence>
    </MotionButton>
  )
}
